// 导入合并reducer的依赖
import { combineReducers } from 'redux'

// 导入 登录 模块的 reducer
import A0Layout from './layout'

// 合并 reducer
const rootReducer = combineReducers({
  A0Layout,
})

// 默认导出
export default rootReducer
